"use client";

import React from "react";
import Image from "next/image";
import styles from "./service-row-badge.module.scss";
import { getChainName, getChainLogo } from "../../utils/chain-utils";

interface ServiceRowBadgeProps {
  /** Whether the service/item is healthy */
  isHealthy: boolean;
  /** Service or item name */
  serviceName: string;
  /** Chain ID for chain-specific services, null for global */
  chainId: number | null;
  /** Additional subtitle/description */
  subtitle?: string;
  /** Metrics to display on the right side */
  metrics: Array<{
    label: string;
    value: string;
  }>;
  /** Optional click handler */
  onClick?: () => void;
}

const ServiceRowBadge: React.FC<ServiceRowBadgeProps> = ({
  isHealthy,
  serviceName,
  chainId,
  subtitle,
  metrics,
  onClick
}) => {
  const chainName = subtitle || getChainName(chainId);
  const chainLogo = getChainLogo(chainId);

  return (
    <div
      className={`${styles.serviceRowBadge} ${isHealthy ? styles.serviceRowBadgeHealthy : styles.serviceRowBadgeUnhealthy}`}
      onClick={onClick}
    >
      <div className={styles.serviceInfo}>
        <Image
          src={chainLogo}
          alt={chainName}
          width={24}
          height={24}
          className={styles.chainLogo}
        />
        <div className={styles.serviceDetails}>
          <span className={styles.serviceName}>{serviceName}</span>
          <span className={styles.chainName}>{chainName}</span>
        </div>
      </div>

      <div className={styles.serviceMetrics}>
        {metrics.map((metric, index) => (
          <div key={index} className={styles.metric}>
            <span className={styles.label}>{metric.label}</span>
            <span className={styles.value}>{metric.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceRowBadge;
